import helpers from './helpers';
import Share from 'ninelines-sharing';

helpers.$body.on('click', '[data-social]', (e) => {
	const social = $(e.currentTarget).data('social');
	
	let url = location.origin + location.pathname;
	
	if (location.origin.search('kp-bayer') != -1) {
		url = location.origin;
	}

	if ($('.main').data('name') !== 'home') {
		url += `/share.php?pages=${$('.main').data('name')}`;
	}
	
	url = url.replace('/corn.html', '');
	url = url.replace('/potato.html', '');
	url = url.replace('/wheat.html', '');	
	
	Share[social](url);
});

helpers.$body.on('click', '[data-socialy]', (e) => {
	const social = $(e.currentTarget).data('socialy');
	
	let url = `${location.origin + location.pathname}/share.php`;
	
	if (location.origin.search('kp-bayer') != -1) {
		url = `${location.origin}/share.php`;
	}

	url = url.replace('/corn.html', '');
	url = url.replace('/potato.html', '');
	url = url.replace('/wheat.html', '');	
	
	Share[social](url);
});

helpers.$body.on('click', '[data-social2]', (e) => {
	const social = $(e.currentTarget).data('social2');
	
	let url = location.origin + location.pathname + `/share.php?pages=${$('.main').data('name')}-final`;
	
	if (location.origin.search('kp-bayer') != -1) {
		url = location.origin + `/share.php?pages=${$('.main').data('name')}-final`;
	}
	
	url = url.replace('/corn.html', '');
	url = url.replace('/potato.html', '');
	url = url.replace('/wheat.html', '');	
	
	Share[social](url);
});